import React, {
  forwardRef, useImperativeHandle, useRef
} from 'react';
import { useTranslation } from 'react-i18next';
import FormPanel from 'components/FormPanel';
import FormButtons from 'components/FormButtons';
import { FormTemplate } from 'data/template/template.types';
import Form, { FieldUpdateHandlerParam } from 'shared/form';
import { NetworkTopologyFilter } from 'data/network-topology/network-topology.types';
import NetworkTopologyFilterForm from '../NetworkTopologyFilterForm';
import NetworkTopologyTooltip from '../NetworkTopologyTooltip';

import './network-topology-toolbar.scss';

type Props = {
  template: FormTemplate,
  filters: NetworkTopologyFilter[],
  data: Partial<any> // TODO: ajust type
  onClickExport: () => void,
  onFieldUpdate: (param: FieldUpdateHandlerParam) => void,
  onFilterSelection: (selected?: NetworkTopologyFilter) => void,
  onRemoveView: (id: string) => void,
  onClear: () => void,
  onSave: (name: string) => void,
  handleBlur: (e: any) => void,
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => any // TODO: ajust type
}

export const NetworkTopologyToolbar = forwardRef<Ref, Props>(({
  template,
  filters,
  data,
  onFieldUpdate,
  onFilterSelection,
  onRemoveView,
  onClickExport,
  onSave,
  onClear,
  handleBlur
}: Props, ref) => {
  const { t } = useTranslation();
  const mainRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    return mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
  };

  const getValues = () => {
    const {
      networkIdHint,
      ...values
    } = mainRef.current?.getValues();

    const formValues: any = { // TODO: ajust type
      ...values,
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  return (
    <div className="network-topology-toolbar">
      <FormPanel title={t('networkTopology.view.title')}>
        {/* TODO: hidden in network topology version 1. re-enable next versions
          <NetworkTopologyTooltip
            shouldTooltip={shouldShowNetworkTopologyFilters}
            content="Please upgrade the license to have full access"
          >
            <FormButtons isEditing={false} onClickExport={onClickExport} />
          </NetworkTopologyTooltip>
        */}
      </FormPanel>
      <div className="network-topology-toolbar-form-block">
        <NetworkTopologyFilterForm
          template={template}
          filters={filters}
          data={data}
          onFieldUpdate={onFieldUpdate}
          onFilterSelection={onFilterSelection}
          onRemoveView={onRemoveView}
          onClear={onClear}
          onSave={onSave}
          handleBlur={handleBlur}
        />
      </div>
    </div>
  );
});

export default NetworkTopologyToolbar;
